export const RIOTT_MEDIA_PARAMETERS = {
  CLIENT_NAME: 'Marriott Media Network',
  URL: '/mi/mango/beacon',
  LOADED: 'page_loaded',
  key: 'type',
};

export const MERCHHEROBANNER = {
  HERO: 'hero',
  HERO3BY1: 'home_hero_3:1',
};
